export enum ImageHeight {
	Full = 'Full',
	Half = 'Half',
	Third = 'Third',
}
